'use client';
import React, { ChangeEvent, useState } from 'react';
import { Button, Div, LoadingIndicator, Popper, PopperContent, PopperHandler, Text, TextField } from '@pezeshk-book/ui-kit';
import { useDebouncedCallback } from 'use-debounce';
import SearchIcon from '@icons-components/search-icon';
import { useDispatch, useSelector } from 'react-redux';
import { HomeActions } from '@store/home-screen/home-action';
import { RootState } from '@store/root-reducer';
import SearchSection from './search-section';

const GeneralSearch = () => {
  const dispatch = useDispatch();
  const { searchResult, searchLoading, searchValue } = useSelector((state: RootState) => state.home);

  const [searchField, setSearchField] = useState(false);
  const [searchFieldFocus, setSearchFieldFocus] = useState(false);
  const [showList, setShowList] = useState<boolean>(false);
  const handleSearchField = (open: boolean) => {
    if (!searchFieldFocus) {
      setSearchField(open);
    }
  };

  const handleInputFocus = (focus: boolean) => {
    setTimeout(() => {
      setSearchFieldFocus(focus);
      setSearchField(focus);
    }, 200);
  };

  const handlePopper = () => {
    setShowList(!showList);
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    dispatch(HomeActions.setSearchValue({ value: inputValue }));
    handleSearch(inputValue);
  };

  const handleSearch = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      dispatch(HomeActions.getSearchResults({ searchValue: value }));
      setShowList(true);
    } else {
      dispatch(HomeActions.setSearchResults({
        users: [],
        products: [],
        posts: [],
        is_empty: true,
      }));
    }
  }, 500);

  return (
    <Div onMouseOver={() => handleSearchField(true)} onMouseLeave={() => handleSearchField(false)} className={'relative'}>
      <Div className={`${searchField ? 'translate-x-full opacity-100 delay-75' : '-translate-x-full opacity-0'} transition-all duration-500 ease-in-out absolute z-20`}>
        <Popper position={'bottom'} showPopper={showList} handlePopper={handlePopper} className={'w-full'}>
          <PopperHandler>
            <TextField
              color={'primary'}
              onChange={handleInputChange}
              onFocus={() => handleInputFocus(true)}
              onBlur={() => handleInputFocus(false)}
              value={searchValue}
              size={'small'}
              className={`${searchField ? 'w-96' : 'w-0 delay-200'} transition-[width] duration-500 z-20 absolute -right-4`}
              variant={'outlined'}
              label={'در پزشک بوک بگرد'}
              endAdornment={searchLoading ? <LoadingIndicator color={'primary'} size={'small'} /> : null}
            />
          </PopperHandler>
          <PopperContent className={'w-full left-4 top-10'}>
            <Div className={'bg-white shadow-lg rounded-lg py-6 px-4'}>
              {!searchResult.is_empty ? (
                <Div className={'flex-col w-full gap-4 overflow-y-scroll'}>
                  <SearchSection title={'پزشکان'} type={'users'} loading={searchLoading} data={searchResult.users}/>
                  <SearchSection title={'محصولات'} type={'products'} loading={searchLoading} data={searchResult.products} hasPrice={true} />
                  <SearchSection title={'مجله سلامت'} type={'posts'} lastSection={true} loading={searchLoading} data={searchResult.posts} />
                </Div>
              ) : (
                <Text typography={'sm'}>
                موردی یافت نشد
                </Text>
              )}
            </Div>
          </PopperContent>
        </Popper>
      </Div>
      <Button onMouseOver={() => handleSearchField(true)} onMouseLeave={() => handleSearchField(false)} size={'small'} className={'!z-20'} variant={'outlined'} shape={'square'}>
        <Div className={'w-5 h-5 min-w-5 min-h-5 relative justify-center items-center'}>
          <SearchIcon/>
        </Div>
      </Button>
    </Div>
  );
};

export default GeneralSearch;
